import { ROUTES } from '@/shared/lib/constants/routes';

import { type ConfigurationStep } from './types';

export const EMPTY_CONFIGURATION_MESSAGE = '구성된 항목이 없습니다.';

export const CONFIGURATION_STEPS: readonly ConfigurationStep[] = [
  {
    id: 1,
    label: 'Governance',
    items: [
      {
        label: 'Sematic',
        count: 9,
        disabled: true,
      },
      {
        label: 'Glossary',
        count: 5,
        disabled: true,
      },
      {
        label: 'Tag',
        count: 4,
        disabled: true,
      },
      {
        label: 'Quality',
        count: 6,
        disabled: true,
      },
      {
        label: 'Security',
        count: 2,
        disabled: true,
      },
      {
        label: 'Life Cycle',
        count: 1,
        disabled: true,
      },
    ],
  },
  {
    id: 2,
    label: 'User',
    items: [
      {
        label: 'Account',
        count: 0,
        path: '/admin/users',
      },
    ],
  },
  {
    id: 3,
    label: 'Ingest',
    items: [{ label: 'Departure', count: 6, path: ROUTES.CONNECTORS }],
  },
  {
    id: 4,
    label: 'Contextualize',
    items: [{ label: 'DAG', count: 7, path: ROUTES.DAG }],
  },
  {
    id: 5,
    label: 'Store',
    items: [
      {
        label: 'ICEBERG1',
        count: 3,
        disabled: true,
      },
      {
        label: 'ICEBERG2',
        count: 3,
        disabled: true,
      },
      {
        label: 'ICEBERG3',
        count: 3,
        disabled: true,
      },
    ],
  },
  {
    id: 6,
    label: 'Data Serving',
    items: [
      {
        label: 'Arrival',
        count: 3,
        disabled: true,
      },
    ],
  },
  {
    id: 7,
    label: 'Experiment',
    items: [
      {
        label: 'Artifact',
        count: 5,
        disabled: true,
      },
      {
        label: 'Feature',
        count: 5,
        disabled: true,
      },
      {
        label: 'Param',
        count: 5,
        disabled: true,
      },
      {
        label: 'Inference',
        count: 3,
        disabled: true,
      },
    ],
  },
] as const;
